import { CloseCircleIcon } from '@velocity/icons/system';
import { Button } from '@velocity/ui';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/types';
import Modal from '../../../b2b/components/modal/modal';
import ButtonGroup from '../../../b2b/molecules/button-group/button-group';

interface ConfirmationProps extends React.HTMLAttributes<HTMLDivElement> {
  isOpen: boolean;
  onClose: () => void;
  onLoading?: boolean;
  confirmationText: string;
  cancel: () => void;
  success: () => void;
}

const ConfirmationModal: React.FC<ConfirmationProps> = ({
  isOpen,
  onClose,
  confirmationText,
  cancel,
  onLoading,
  success,
  children,
}) => {
  // Sequence Store
  const { device } = useSelector((state: RootState) => state.sequence);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        type={device === 'mobile' ? 'top' : 'middle'}
        closeButtonVisibility={false}
        direction='up'
        background='transparent'
      >
        <h1 className='title left bottom-24'>{confirmationText}</h1>
        {children}

        <ButtonGroup
          type='default'
          className='top-48'
          buttonOneProps={{
            type: 'button',
            disabled: onLoading,
            children: 'Antrag fortsetzen',
            onClick: () => cancel(),
          }}
          buttonTwoProps={{
            variant: 'secondary-outlined',
            StartIcon: CloseCircleIcon,
            type: 'button',
            loading: onLoading,
            onClick: () => success(),
            children: 'Leasingantrag stornieren',
          }}
        />
      </Modal>
      {isOpen && (
        <Button
          variant='secondary-outlined'
          size='m'
          type='button'
          className='button-ontop mobile-only'
          disabled={onLoading}
          onClick={cancel}
        >
          Fortsetzen
        </Button>
      )}
    </>
  );
};

export default ConfirmationModal;
